import { Box, BoxProps } from "@mui/material";

import React from "react";

const BNBox = React.forwardRef<HTMLDivElement, BoxProps>((props, ref) => {
  return <Box {...(props as any)} ref={ref}></Box>;
});
export default BNBox;
